
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { BAIconsMixin } from '@/mixins';

@Component({
    components: {}
})
export default class AthleteEditInfoDialog extends Mixins(BAIconsMixin) {
    @Prop({ required: true, default: undefined }) value: string;
    @Prop({ default: "Edit Comment"}) title;
    @Prop({ default: "Edit Comment"}) tooltip;
    @Prop({ default: "Not Available" }) disabledTooltip;
    @Prop({ default: 'mdi-note-edit'}) icon;
    @Prop({ default: "" }) class: string;
    @Prop({ type: Boolean }) disabled;
    @Prop({ type: Boolean }) noIcon;
    @Prop({ type: Boolean }) large;
    @Prop({ type: Boolean }) small;
    @Prop({ type: Boolean }) dense;
    @Prop({ type: Boolean }) text;

	editingPlayer: boolean = false;
    backupComment: string;
	onStartEditComment() {
        if( this.disabled ) return;
        
        this.backupComment = this.value;
		this.editingPlayer = true;
	}
	onCancelEditComment() {
        this.value = this.backupComment;
		this.editingPlayer = false;
        this.$emit("cancel");
	}
	async onAcceptEditComment() {
        this.$emit("accept", this.value);
        this.editingPlayer = false;
	}
}

